module.exports = __webpack_public_path__ + "img/07-sm.78b2fd2.webp";